import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { PokemonContext } from '../Context/PokemonContext'

function PokemonCard({ data, pokedexEntry, pokemonImg, pokemonName, index}) {
  const {selectPokemon} = useContext(PokemonContext)
  const fadeInAnimationVariant = {
    initial: {
        opacity: 0,
        translateY: '100%',
    },
    animate: (index) => ({
        opacity: 1,
        translateY: 0,
        transition: {
            delay: 0.01 * index,
            ease: 'easeIn'
        }
    })
}
const handleClick = () => {
  selectPokemon(data)
  navigate(`/${pokemonName}`)
}
const navigate = useNavigate()
  return (
    <motion.div
            onClick={() => handleClick() }
            key={index}
            variants={fadeInAnimationVariant}
            initial="initial"
            animate="animate"
            viewport={{
                once: true,
            }}
            custom={index}
     className='w-[104px] hover:translate-y-1 active:translate-y-2 hover:scale-100 scale-95  cursor-pointer group flex flex-col items-center justify-center relative h-[108px] rounded-[8px] shadow-[0px_1px_3px_1px_#00000070] hover:shadow-[0px_1px_3px_1px_#00000040] active:hover:shadow-[0px_1px_3px_1px_#00000020]'>
        {/* Pokedex # */}
        <div className='absolute top-[6px] right-[8px] text-medium text-[8px] font-bold z-[20]'>#{pokedexEntry}</div>
        {/* Pokemon img */}
        <img className='z-10' src={pokemonImg}/>
        {/* Pokemon name */}
        <div className='w-full transition-all  duration-300 z-0 h-[44px] group-hover:h-full rounded-[7px] group-hover:bg-green-50 absolute bottom-0 bg-[#EFEFEF] flex flex-col items-center justify-center text-[10px] text-[#1D1D1D]'><span className='bottom-[6px] absolute group-hover:font-bold transition-all  duration-300'>{pokemonName}</span></div>
    </motion.div>
  )
}

export default PokemonCard